import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getTimeslotsRequest: ["leave_id", "isTherapist", "children_id", "isReschedule", "make_id", "page"],
  getTimeslotsSuccess: ["timeslots", "timeslotsMake"],
  getTimeslotsFailure: null,
});

export const GetTimeslotsTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  fetching: null,
  success: null,
  timeslots: null,
  timeslotsMake: null,
  error: null,
  page: null,
});

export const GetTimeslotsSelectors = {
  getData: (state: any) => state.getTimeslots.data,
  isFetching: (state: any) => state.getTimeslots.fetching,
  isSuccess: (state: any) => state.getTimeslots.success,
  hasError: (state: any) => state.getTimeslots.error,
};

export const request = (state: any, { leave_id, page }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
    page,
    timeslots: null,
    timeslotsMake: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { timeslots, timeslotsMake } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    timeslots,
    timeslotsMake,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    timeslots: null,
    timeslotsMake: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_TIMESLOTS_REQUEST]: request,
  [Types.GET_TIMESLOTS_SUCCESS]: success,
  [Types.GET_TIMESLOTS_FAILURE]: failure,
});
